import { Flex, Heading, Link, Text } from '@chakra-ui/react';

import { MarketplaceVehicle, formatVehicleSummary } from '../../../../../utils/cars';
import getSearchPhoneNumbers from '../../../../../utils/getSearchPhoneNumbers';
import MarketplaceCard from '../MarketplaceCard';

type MarketplaceEndedProps = {
  vehicle: MarketplaceVehicle;
};

const MarketplaceEnded = ({ vehicle }: MarketplaceEndedProps) => {
  const phone = getSearchPhoneNumbers();

  return (
    <MarketplaceCard alignItems="center" justifyContent="center">
      <Flex direction="column" align="center" textAlign="center">
        <Heading
          as="h2"
          fontFamily="heading"
          fontSize="22px"
          fontWeight="700"
          color="leaseEndBlue"
          letterSpacing="-0.01em"
        >
          This listing has ended
        </Heading>

        <Text fontSize="13.5px" color="gray.600" lineHeight="1.55" maxW="48ch" mt="14px">
          Your car is no longer listed on the marketplace. If you have questions, your Lease End
          reps are here to help.
        </Text>

        <Text fontSize="13.5px" color="gray.500" mt="10px">
          <Link href={`tel:+1${phone.replace(/\D/g, '')}`} fontWeight="600" color="oceanBoatBlue">
            Call us at {phone}
          </Link>
        </Text>

        <Flex
          direction="column"
          gap="4px"
          mt="24px"
          px="18px"
          py="14px"
          minW="260px"
          bg="grayLightBackground"
          borderWidth="1px"
          borderColor="grayMediumBackground"
          borderRadius="10px"
        >
          <Text
            fontSize="10px"
            fontWeight="700"
            letterSpacing="0.16em"
            textTransform="uppercase"
            color="grayMedium"
          >
            Your vehicle
          </Text>
          <Text fontFamily="heading" fontSize="15px" fontWeight="700" color="leaseEndBlue">
            {formatVehicleSummary(vehicle)}
          </Text>
        </Flex>
      </Flex>
    </MarketplaceCard>
  );
};

export default MarketplaceEnded;
